import { sendRequestAuth } from 'api/api'
import { Button } from 'common/button'
import config from 'config'
import useInvoiceFilterForm from 'Pages/invoice/hooks/useInvoiceFilterForm'
import { InvoiceContext } from 'Pages/invoice/provider/_context'
import { invoiceActions } from 'Pages/invoice/provider/_reducer'
import React, { memo, useContext, useEffect } from 'react'
import { InvoiceTags } from '../invoiceTags'
import { InvoiceDateTime } from './_dateTime'
import { StyledInvoiceFilterForm } from './_styled'
import { InvoiceInfo } from './_info'
import { InvoiceEmployee } from './_teacher'
import { GLOBAL_ICONS } from '../../../../interface/icon'
import { InvoiceStatus } from './_status'
import { PaymentSchedule } from './_paymentSchedule'

export const InvoiceFilterForm = memo(({ ...props }) => {
  const { canSubmitOtherFilter, functions } = useInvoiceFilterForm()

  const { pageDispatch } = useContext(InvoiceContext)

  useEffect(() => {
    const fetchData = async () => {
      const response = await Promise.all([
        sendRequestAuth(
          'get',
          `${
            config.API
          }/commission/filter/teachers?keyword=&group=&status=&start=0&per_page=20`,
        )
      ])
      pageDispatch({
        type: invoiceActions.FILTER_ORIGIN_DATA_UPDATE,
        payload: {
          teacher: {
            list: response[0].data.map(item => ({
              data: item || null,
              name: ((item?.last_name || '') + ' ' + item?.name) || '',
              value: item?.id || '',
            })),
          },
        },
      })
    }
    fetchData()
  }, [])

  return (
    <StyledInvoiceFilterForm {...props}>
      <div
        className="invoice-filter-form__group invoice-filter-form__collapse"
        data-collapse={true}
      >
        <InvoiceInfo/>
        <InvoiceDateTime/>
        <InvoiceEmployee/>
        <PaymentSchedule/>
        <InvoiceStatus/>
        <div className="invoice-filter-form__input-wide flex">
          <Button
            appearance="secondary"
            disabled={!canSubmitOtherFilter}
            size="md-"
            onClick={() =>
              canSubmitOtherFilter && functions.applyInvoiceOtherFilter()
            }
          >
            Tìm kiếm
          </Button>
          <Button
            appearance="secondary"
            size="md-"
            onClick={functions.refresh}
            className={'invoice-filter-form__btn-refresh'}
          >
            {GLOBAL_ICONS.repeat}
          </Button>
        </div>
      </div>
      <div className="invoice-filter-form__group" style={{ marginBottom: 4 }}>
        <InvoiceTags/>
      </div>
    </StyledInvoiceFilterForm>
  )
})
